<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="6">
            <label>稿件编号：</label>
            <a-input
              placeholder="请输入"
              v-model="queryCode"
              class="query_input"
            />
          </a-col>
          <a-col :span="6">
            <label>标题：</label>
            <a-input
              placeholder="请输入"
              v-model="queryCnTitle"
              class="query_input"
            />
          </a-col>
          <a-col :span="6">
            <label>作者：</label>
            <a-input
              placeholder="请输入"
              v-model="queryAuthorName"
              class="query_input"
            />
          </a-col>
          <a-col :span="4">
            <label>状态：</label>
            <a-select
              placeholder="请选择"
              v-model="queryAuditStatus"
              class="query_input"
            >
              <a-select-option :value="21">全部</a-select-option>
              <a-select-option :value="1">未查重</a-select-option>
              <a-select-option :value="2">已查重</a-select-option>
              <a-select-option :value="3">查重通过</a-select-option>
              <a-select-option :value="33">需退改</a-select-option>
              <a-select-option :value="44">需退稿</a-select-option>
            </a-select>
          </a-col>
          <a-button type="primary" class="query_btn" @click="query">
            查询
          </a-button>
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div class="sortType" style="float: right">
        排序方式：
        <a-select
          size="small"
          defaultValue="1"
          style="width: 120px"
          @change="sortChange"
          v-model="sort"
        >
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="(record) => record.code"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operator" slot-scope="text, record">
            <a
              href="javascript:void(0);"
              @click="() => manage(record)"
              v-if="record.auditStatus > 1"
            >
              稿件处理
            </a>
            <template v-if="record.auditStatus == 1">
              <a href="javascript:void(0);" @click="() => saveRate(record)">
                重复率
              </a>
              <a-divider type="vertical" />
              <a href="javascript:void(0);" @click="() => download(record)">
                下载
              </a>
            </template>
          </span>
          <template slot="sort" slot-scope="text, record, index">
            {{ `${(page - 1) * limit + index + 1}` }}
          </template>
          <template slot="auditStatus" slot-scope="auditStatus, record">
            <template v-if="record.result == 0">
              <span v-if="auditStatus == 1">未查重</span>
              <span v-if="auditStatus == 2" style="color: red">已查重</span>
              <span v-if="auditStatus == 3">查重通过</span>
              <span v-if="auditStatus == 6">主编审核通过</span>
            </template>
            <template v-else>
              <span v-if="record.result == 33">需退改</span>
              <span v-if="record.result == 44">需退稿</span>
            </template>
          </template>
          <template slot="repetitionRate" slot-scope="text, record">
            <span v-if="record.auditStatus == 1">--</span>
            <span v-if="record.auditStatus == 2" style="color: red">
              {{ text }}%
            </span>
            <span v-if="record.auditStatus == 3">{{ text }}%</span>
          </template>
          <span slot="code" slot-scope="text, record">
            <label @click="manuscriptsInfo(record)" class="view_manu">{{
              record.code
            }}</label>
          </span>
          <span slot="cnTitle" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ record.cnTitle }}</span>
              </template>
              <div class="shenglue">
                <label @click="preview(record)" class="view_manu">{{
                  record.cnTitle
                }}</label>
              </div>
            </a-tooltip>
          </span>
        </a-table>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="(total) => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select
        defaultValue="0"
        class="batch_operation"
        @change="operateChange"
        v-model="operateCode"
      >
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
        <a-select-option value="2">批量下载</a-select-option>
      </a-select>
      <div class="batch_operation">
        <a-button
          type="primary"
          @click="importManuscript"
          style="margin-left: 10px"
        >
          导入稿件
        </a-button>
      </div>
      <div class="batch_operation" style="width: 300px">
        <a-upload
          name="file"
          :action="importAddress"
          :headers="headers"
          @change="uploadAdd"
          :withCredentials="true"
          accept=".xls"
        >
          <a-button type="primary" style="margin-left: 10px">
            导入查重结果
          </a-button>
        </a-upload>
      </div>
    </div>

    <a-modal
      title="导入稿件"
      v-model="importVisible"
      :dialog-style="{ top: '20px' }"
      width="1200px"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <ImportManuscript @importClose="importClose" />
    </a-modal>

    <ManuscriptInfo ref="manuscriptInfo" :infoData="manuscript" />
  </div>
</template>


<script>
const columns = [
  {
    title: "序号",
    dataIndex: "sort",
    width: 60,
    scopedSlots: { customRender: "sort" },
  },
  {
    title: "稿件编号",
    dataIndex: "code",
    width: 130,
    scopedSlots: { customRender: "code" },
  },
  {
    title: "标题",
    dataIndex: "cnTitle",
    scopedSlots: { customRender: "cnTitle" },
  },
  {
    title: "学科",
    dataIndex: "discipline",
  },
  {
    title: "作者",
    width: 90,
    dataIndex: "authorName",
  },
  {
    title: "所在单位",
    dataIndex: "companyName",
  },
  {
    title: "版本",
    width: 130,
    dataIndex: "sectionInfo",
  },
  {
    title: "栏目",
    dataIndex: "columnInfo",
  },
  {
    title: "稿件字数",
    width: 90,
    dataIndex: "wordCount",
  },
  {
    title: "状态",
    width: 110,
    dataIndex: "auditStatus",
    scopedSlots: { customRender: "auditStatus" },
  },
  {
    title: "查重率",
    width: 90,
    dataIndex: "repetitionRate",
    scopedSlots: { customRender: "repetitionRate" },
  },
  {
    title: "操作",
    width: 140,
    key: "action",
    scopedSlots: { customRender: "operator" },
  },
];

import qs from "qs";
import ManuscriptInfo from "../../../commomon/ManuscriptInfo.vue";
import ImportManuscript from "./ImportManuscript.vue";
export default {
  name: "MyManuscripts",
  components: {
    ManuscriptInfo,
    ImportManuscript,
  },
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      importAddress:
        this.$config.serviceAddress + "/manuscripts/importRepetitionRate",
      headers: {
        authorization: "authorization-text",
      },
      manuscript: {},
      data: [],
      columns,
      selectedRowKeys: [],
      queryCode: "",
      queryCnTitle: "",
      queryAuthorName: "",
      queryType: "",
      queryEditorName: "",
      queryAuditStatus: 21,
      sort: "1",
      sortField: "code",
      sortType: "desc",
      operateCode: "0",
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
      addList: [],
      rate: null,
      importVisible: false,
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.auditStatus !== 1,
          },
        }),
      };
    },
  },
  created() {
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    //预览稿件
    preview(record) {
      var codes = [];
      codes.push(record.code);
      this.axios
        .post("/manuscriptsAddFile/queryByCode", {
          codes: JSON.stringify(codes),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            var addFile = res.data.data;
            if (addFile.length > 0) {
              this.$router.push({
                path: "/edit/preview",
                query: { fileCode: addFile[0].code },
              });
            } else {
              this.utils.messageInfo(this, "error", "稿件不存在！");
            }
          } else {
            this.utils.messageInfo(this, "error", "查询稿件失败！");
          }
        });
    },
    manuscriptsInfo(record) {
      this.manuscript = record;
      this.$refs.manuscriptInfo.show();
    },
    manage(record) {
      this.$router.push({
        path: "/deal/manager",
        query: {
          code: record.code,
          type: record.type,
          auditStatus: record.auditStatus,
        },
      });
    },
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "code";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "code";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.query();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == "1") {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(
            this,
            "error",
            "获取后台ip地址失败，无法导出！"
          );
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(
          this.serviceAddress +
            "/manuscripts/exportData?codeArr=" +
            selectedRowKeys +
            "&type=2"
        );
      } else if (this.operateCode == "2") {
        //批量下载
        window.open(
          this.serviceAddress +
            "/manuscripts/downLoadBatch?codes=" +
            this.selectedRowKeys.join() +
            "&excel=true&zipName=待查重稿件"
        );
      }
      this.operateCode = "0";
    },
    query() {
      this.axios
        .get("/manuscripts/myManuscripts", {
          params: {
            code: this.queryCode,
            cnTitle: this.queryCnTitle,
            authorName: this.queryAuthorName,
            type: this.queryType,
            status: 2,
            auditStatus: this.queryAuditStatus,
            userCode: sessionStorage.getItem("userCode"),
            sortField: this.sortField,
            sortType: this.sortType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询稿件列表失败！");
          }
        });
    },
    saveRate(record) {
      let _this = this;
      this.$confirm({
        title: "添加重复率",
        content: (h) => {
          return h("a-input", {
            attrs: {
              placeholder: "请输入重复率",
              value: _this.rate,
            },
            on: {
              input: (e) =>
                (_this.rate = e.target.value.replace(/[^0-9.]/g, "")),
            },
          });
        },
        onOk: () => {
          if (this.rate == null || this.rate == "") {
            _this.utils.messageInfo(this, "error", "请输入重复率");
            _this.$refs.confirmModal.cancelLoading();
          }
          this.axios
            .post("/manuscripts/changeAuditStatus", {
              code: record.code,
              rate: this.rate,
              statusList: this.rate > 20 ? "2" : "3",
              type: 1,
              time: new Date().getTime(),
            })
            .then((res) => {
              if (res.data.code == "OK") {
                this.utils.messageInfo(this, "success", "添加重复率成功");
                this.query();
                this.rate = "";
              } else {
                this.utils.messageInfo(this, "error", "添加重复率失败");
              }
            });
        },
        onCancel() {},
      });
    },
    download(record) {
      window.open(
        this.serviceAddress + "/manuscripts/downLoad?code=" + record.code
      );
    },
    uploadAdd(info) {
      this.addList = [];
      if (info.file.status !== "uploading") {
        this.addList = info.fileList;
      }
      if (info.file.status === "done") {
        if (info.file.response.code == "OK") {
          this.utils.messageInfo(this, "success", "上传成功");
          this.query();
        } else {
          this.utils.messageInfo(this, "error", "上传失败");
        }
      } else if (info.file.status === "error") {
        this.utils.messageInfo(this, "error", "上传失败");
      }
    },
    addRemove() {
      this.addList = [];
    },
    importManuscript() {
      this.importVisible = true;
    },
    importClose() {
      this.importVisible = false;
      this.query();
    }
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
</style>
